import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// Selinhos de reação, presos à borda de baixo da bolha como no WhatsApp.
const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === "dark";
  return {
    wrap: {
      position: "absolute",
      bottom: -20,
      zIndex: 2,
      display: "flex",
      gap: 3,
      maxWidth: "100%",
      whiteSpace: "nowrap",
    },
    left: { left: 6 },
    right: { right: 6 },
    chip: {
      display: "inline-flex",
      alignItems: "center",
      gap: 3,
      height: 24,
      minWidth: 28,
      padding: "0 6px",
      margin: 0,
      borderRadius: 12,
      // contorno na cor do fundo da conversa: o selinho "recorta" a bolha
      border: `1.5px solid ${isDark ? "#0b141a" : "#efeae2"}`,
      backgroundColor: isDark ? "#202c33" : "#ffffff",
      boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)",
      color: isDark ? "rgba(233,237,239,0.7)" : "#667781",
      font: "inherit",
      fontSize: 12,
      lineHeight: "20px",
      cursor: "default",
      userSelect: "none",
    },
    mine: {
      cursor: "pointer",
      backgroundColor: isDark ? "#103a32" : "#e7fce3",
      "&:hover": { backgroundColor: isDark ? "#14463d" : "#d9fdd3" },
      "&:focus-visible": { outline: "2px solid #00a884", outlineOffset: 1 },
    },
    emoji: {
      fontSize: 15,
      lineHeight: "20px",
      fontFamily: '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif',
    },
    count: { fontWeight: 500 },
  };
});

const ReactionChips = ({ reactions, fromMe, onRemove }) => {
  const classes = useStyles();
  if (!reactions || !reactions.items || reactions.items.length === 0) return null;

  return (
    <div className={clsx(classes.wrap, fromMe ? classes.right : classes.left)} onDoubleClick={(e) => e.stopPropagation()}>
      {reactions.items.map((item) => {
        const who = [item.mine ? i18n.t("conversation.reactions.you") : null, ...item.names].filter(Boolean).join(", ");
        const title = item.mine
          ? `${who} · ${i18n.t("conversation.reactions.clickToRemove")}`
          : who || undefined;
        return (
          <button
            key={item.emoji}
            type="button"
            className={clsx(classes.chip, item.mine && classes.mine)}
            title={title}
            aria-label={`${item.emoji} ${item.count}${who ? ` — ${who}` : ""}`}
            onClick={item.mine && onRemove ? () => onRemove(item.emoji) : undefined}
            tabIndex={item.mine ? 0 : -1}
          >
            <span className={classes.emoji}>{item.emoji}</span>
            {item.count > 1 && <span className={classes.count}>{item.count}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default ReactionChips;
